<template>
  <el-container class="app-layout">
    <el-header class="header">
      <div class="header-logo">合作商管理后台</div>
      <div class="header-right">
        <span class="header-logout"
          ><i class="el-icon-user-solid"></i
          >{{ userInfo.realName || "管理员" }}</span
        >
        <span class="header-logout" @click="handleLogout">
          <i class="el-icon-switch-button"></i>退出登录</span
        >
      </div>
    </el-header>

    <el-container class="page-body">
      <el-aside width="220px" class="aside">
        <el-menu
          :default-active="$route.path"
          class="menu"
          :default-openeds="defaultOpeneds"
        >
          <template v-for="item in menuItems">
            <el-submenu
              v-if="item.children && item.children.length"
              :key="item.path"
              :index="item.path"
            >
              <template slot="title">
                <i :class="item.icon"></i>
                {{ item.title }}
              </template>
              <el-menu-item
                v-for="child in item.children"
                :key="child.path"
                :index="child.path"
                @click="goTo(child.path)"
              >
                <i :class="child.icon"></i>
                {{ child.title }}
              </el-menu-item>
            </el-submenu>

            <el-menu-item
              v-else
              :key="item.path"
              :index="item.path"
              @click="goTo(item.path)"
            >
              <i :class="item.icon"></i>
              {{ item.title }}
            </el-menu-item>
          </template>
        </el-menu>
      </el-aside>

      <el-main class="main-content">
        <div class="breadcrumb-wrap">
          <el-breadcrumb separator="/" class="breadcrumb">
            <el-breadcrumb-item
              v-for="(item, index) in breadcrumbItems"
              :key="index"
              @click="goTo(item.path)"
              style="cursor: pointer"
            >
              {{ item.title }}
            </el-breadcrumb-item>
          </el-breadcrumb>
        </div>

        <div class="view-container">
          <router-view />
        </div>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import { UserLogout } from "@/api/login/index";
import { asyncRoutes } from "@/router/asyncRoutes";

export default {
  name: "Dashboard",
  data() {
    return {
      userInfo: sessionStorage.getItem("userInfo")
        ? JSON.parse(sessionStorage.getItem("userInfo"))
        : { realName: "管理员" },
    };
  },
  computed: {
    // ===== 菜单项（动态路由） =====
    menuItems() {
      const permissions = JSON.parse(
        sessionStorage.getItem("permissions") || "[]",
      );

      const filterRoutes = (routes) => {
        return routes
          .map((route) => {
            const routePermission = route.meta?.permission;
            const hasPermission = routePermission
              ? permissions.includes(routePermission)
              : true;

            let filteredRoute = null;
            if (route.children && route.children.length) {
              const filteredChildren = filterRoutes(route.children);
              if (filteredChildren.length > 0) {
                filteredRoute = { ...route, children: filteredChildren };
              }
            }

            if (hasPermission || filteredRoute) {
              const tmp = filteredRoute ? filteredRoute : { ...route };
              if (!tmp.children) {
                delete tmp.children;
              }
              return tmp;
            }
            return null;
          })
          .filter((route) => route !== null);
      };

      const allowedRoutes = filterRoutes(asyncRoutes);
      const children = [
        {
          path: "dashboard",
          name: "dashboard",
          meta: { title: "数据统计", icon: "el-icon-s-home", menu: true },
        },
        ...allowedRoutes,
      ];

      const resolvePath = (routePath, parentPath = "/home") => {
        if (!routePath || routePath === "/") {
          return parentPath || "/";
        }
        if (routePath.startsWith("/")) {
          return routePath;
        }
        const normalizedParent =
          parentPath && parentPath !== "/" ? parentPath : "";
        return `${normalizedParent}/${routePath}`.replace(/\/+/g, "/");
      };

      const build = (routes, parentPath = "/home") => {
        return routes
          .filter((route) => {
            return route.meta && route.meta.title && route.meta.menu !== false;
          })
          .map((route) => {
            const path = resolvePath(route.path, parentPath);
            const item = {
              title: route.meta.title,
              path,
              icon: route.meta.icon || "el-icon-menu",
            };
            if (route.children && route.children.length) {
              item.children = build(route.children, path);
            }
            return item;
          });
      };

      return build(children);
    },

    // ===== 默认展开的菜单 =====
    defaultOpeneds() {
      const current = this.$route.path;
      const opened = [];
      this.menuItems.forEach((item) => {
        if (
          item.children &&
          item.children.some((child) => child.path === current)
        ) {
          opened.push(item.path);
        }
      });
      return opened;
    },

    // ===== 面包屑 =====
    breadcrumbItems() {
      return this.$route.matched
        .filter((route) => route.meta && route.meta.title && route.path !== "")
        .map((route) => ({
          title: route.meta.title,
          path: route.path,
        }));
    },
  },
  methods: {
    handleLogout() {
      UserLogout()
        .then((res) => {
          if (res.data.isSuccess) {
            sessionStorage.clear();
            this.$router.push("/login");
            this.$message.success(res.data.message);
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch(() => {
          this.$message.error("退出登录失败，请稍后再试");
        });
    },
    goTo(path) {
      console.log("Navigating to:", path, this.$route.path);
      if (path === this.$route.path) {
        this.$router.push({
          path: "/black",
          query: { path: path },
        });
        return;
      }
      this.$router.push(path);
    },
  },
};
</script>

<style scoped>
@import "../assets/css/common.css";

.app-layout {
  height: 100vh;
  overflow: hidden;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #2a87e1;
  padding: 0 24px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.header-logo {
  color: #fff;
  font-size: 23px;
}

.header-right {
  display: flex;
  align-items: center;
  color: #fff;
}

.header-right span {
  margin-left: 16px;
}

.header-logout {
  font-size: 13px;
  color: #eee;
  cursor: pointer;
}

.page-body {
  height: calc(100vh - 64px);
}

.aside {
  background-color: #ffffff;
  height: 100%;
  overflow: auto;
}

.menu {
  border: none;
}

.breadcrumb-wrap {
  padding: 12px 16px;
  margin-bottom: 16px;
}

.main-content {
  padding: 20px;
  background-color: #f2f6fc;
  height: 100%;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.view-container {
  flex: 1;
  overflow: auto;
  padding-right: 10px;
  max-height: calc(100% - 40px);
  width: 100%;
  margin: 0 auto;
  box-sizing: border-box;
  background: #fff;
  padding: 20px;
  border-radius: 4px;
}

.breadcrumb {
  background: transparent;
}
</style>
